import fetchQcEventHistory from "./qrEventHistory.api";
import getQcImpactByMonth from "../overallReporting/credit/getQcImpactByMonth.api";
import getQcFailByProduct from "../overallReporting/credit/getQcFailByProduct.api";

const CreditReportingApi = {
  fetchQcEventHistory,
  getQcImpactByMonth,
  getQcFailByProduct,
};

export default CreditReportingApi;